var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.578,
    height: 20,
    viewBox: "0 0 17.578 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    "data-name": "Group 1818",
    transform: "translate(3.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1817",
    "data-name": "Group 1817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3250",
    "data-name": "Path 3250",
    d: "M126.554,0a5.554,5.554,0,1,0,5.554,5.554A5.56,5.56,0,0,0,126.554,0Z",
    transform: "translate(-121 0)",
    fill: "#3160d4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1820",
    "data-name": "Group 1820",
    transform: "translate(0 11.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3251",
    "data-name": "Path 3251",
    d: "M46.35,302.394A7.336,7.336,0,0,0,40.961,300H38.617a7.336,7.336,0,0,0-5.389,2.394A8.32,8.32,0,0,0,31,308.1a.6.6,0,0,0,.586.617H47.992a.6.6,0,0,0,.586-.617A8.32,8.32,0,0,0,46.35,302.394Z",
    transform: "translate(-31 -300)",
    fill: "#3160d4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profileActive.8c7c903096f9eb98ea8179362cdd860f.svg";
export { ForwardRef as ReactComponent };